exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-connect[data-v-3d2ee85e] {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 40px;\n}\n@media (max-width: 479px) {\n.social-connect[data-v-3d2ee85e] {\n    flex-wrap: wrap;\n}\n}", ""]);

// exports
